import { DASHBOARD_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: DASHBOARD_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/Main'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/dashboard/index.js